import { G2S } from '../g2s';

export class String {

    static currencySymbol(value: string): string {
        switch (value) {
            case 'RUB':
            case 'RUR':
                return '\u20bd';
            case 'AED':
                return 'AED';
            case 'AUD':
                return 'AUD';
            case 'AZN':
                return '₼';
            case 'BRL':
                return 'BRL';
            case 'CAD':
                return 'C$';
            case 'EUR':
                return '€';
            case 'GBR':
                return '£';
            case 'ILS':
                return '₪';
            case 'INR':
                return '₹';
            case 'JPY':
                return '¥';
            case 'KZT':
                return '₸';
            case 'MXN':
                return 'MXN';
            case 'PLN':
                return 'PLN';
            case 'USD':
                return '$';
            default:
                return value;
        }
    }

    static isEmail(value: string): boolean {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (value) {
            return re.test(value);
        }

        return false;
    }

    static normalizeCardHolder(value: string, wrongSymbolCallback?: Function): string {
        // eslint-disable-next-line no-useless-escape
        const replaceRegex = /[^a-z .\'-]/gi;

        if (value) {
            const regexIsMatch = replaceRegex.test(value);

            value = value.toUpperCase();
            value = value.replace(/\s{2,}/g, ' ');
            value = value.replace(replaceRegex, '');

            if (regexIsMatch && wrongSymbolCallback) {
                wrongSymbolCallback();
            }
        }

        return value;
    }

    static normalizeCoupon(value: string): string {
        const replaceRegex = /[^a-zA-Z0-9]/gi;

        if (value) {
            value = value.toUpperCase();
            value = value.replace(/^\s+|\s+$/g, ''); // Trim
            value = value.replace(replaceRegex, '');
        }

        return value;
    }

    static normalizeMilesCard(value: string, wrongSymbolCallback?: Function): string {
        const replaceRegex = /[^a-zA-Z0-9]/gi;

        if (value) {
            const regexIsMatch = replaceRegex.test(value);

            value = value.toUpperCase();
            value = value.replace(/^\s+|\s+$/g, ''); // Trim
            value = value.replace(replaceRegex, '');

            if (regexIsMatch && wrongSymbolCallback) {
                wrongSymbolCallback();
            }
        }

        return value;
    }

    static normalizeNumber(value: string): string {
        if (value) {
            value = value.replace(/[^\d]/gi, '');
        }

        return value;
    }
    
    static disabledCyrillic(value: string, wrongSymbolCallback?: Function): string {
        const replaceRegex = /[^a-zA-Z0-9.@+-_]/gi;

        if (value) {
            const regexIsMatch = replaceRegex.test(value);

            value = value.replace(/^\s+|\s+$/g, ''); // Trim
            value = value.replace(replaceRegex, '');

            if (regexIsMatch && wrongSymbolCallback) {
                wrongSymbolCallback();
            }
        }

        return value;
    }

    static normalizePassengerName(value: string, allowCyrillic: boolean, wrongSymbolCallback?: Function, allowSpaceSymbol?: boolean): string {
        let replaceRegex = allowCyrillic ? /[^а-яёА-ЯЁa-zA-Z]/gi : /[^a-zA-Z]/gi;

        if (allowSpaceSymbol) {
            replaceRegex = allowCyrillic ? /[^а-яёА-ЯЁa-zA-Z ]/gi : /[^a-zA-Z ]/gi;
        } else {
            replaceRegex = allowCyrillic ? /[^а-яёА-ЯЁa-zA-Z]/gi : /[^a-zA-Z]/gi;
        }

        if (value) {
            const regexIsMatch = replaceRegex.test(value);

            value = value.toUpperCase();
            // value = value.replace(/^\s+|\s+$/g, ''); // Trim
            value = value.replace(replaceRegex, '');

            if (regexIsMatch && wrongSymbolCallback) {
                wrongSymbolCallback();
            }
        }

        return value;
    }

    static normalizePassengerLastName(value: string, allowCyrillic: boolean, wrongSymbolCallback?: Function): string {
        let replaceRegex = allowCyrillic ? /[^а-яёА-ЯЁa-zA-Z]/gi : /[^a-zA-Z]/gi;

        replaceRegex = allowCyrillic ? /[^а-яёА-ЯЁa-zA-Z]/gi : /[^a-zA-Z]/gi;

        if (value) {
            const regexIsMatch = replaceRegex.test(value);

            value = value.toUpperCase();
            // value = value.replace(/^\s+|\s+$/g, ''); // Trim
            value = value.replace(replaceRegex, '');

            if (regexIsMatch && wrongSymbolCallback) {
                wrongSymbolCallback();
            }
        }

        return value;
    }

    static normalizeDocumentNumber(value: string, allowCyrillic: boolean, wrongSymbolCallback?: Function): string {
        const replaceRegex = allowCyrillic ? /[^а-яёА-ЯЁa-zA-Z0-9]/gi : /[^a-zA-Z0-9]/gi;

        if (value) {
            const regexIsMatch = replaceRegex.test(value);

            value = value.toUpperCase();
            value = value.replace(/^\s+|\s+$/g, ''); // Trim
            value = value.replace(replaceRegex, '');

            if (regexIsMatch && wrongSymbolCallback) {
                wrongSymbolCallback();
            }
        }

        return value;
    }

    static normalizePhone(value: string): string {
        if (value) {
            value = value.replace(/^\s+|\s+$/g, ''); // Trim
            // eslint-disable-next-line no-useless-escape
            value = value.replace(/[^ \d\+\-\(\)]/gi, '');
        }

        return value;
    }

    static startsWith(sourceString: string, searchString: string, position?: number): boolean {
        if (sourceString) {
            return sourceString.substr(position || 0, searchString.length) === searchString;
        }
        return false;
    }

    static trim(value: string): string {
        if (value) {
            value = value.replace(/^\s+|\s+$/g, '');
        }

        return value;
    }

    static camelToKebab(value: any): any {
        switch(typeof value) {
            case 'string':
                return value.split('').map((letter, idx) => {
                    return letter.toUpperCase() === letter
                        ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
                        : letter;
                }).join('');
                break;
            case 'number':
                return value.toString();
                break;
            default:
                return value;
                break;
        }
    }
}
